import {useTranslation} from "react-i18next";

export default function Or() {
    let {t} = useTranslation();
    return <div className={"flex items-center my-6 gap-5"}>
        <div className={'border-t border-slate-800 grow'}></div>
        <div className={'text-sm text-slate-500 italic'}>{t('or')}</div>
        <div className={'border-t border-slate-800 grow'}></div>
    </div>;
}